import * as React from 'react';
import { Panes, Pane } from '../../components/Panes';
import { useHistory } from '../../hooks';
import { SubmitButton } from '../../components/SubmitButton';
import { PaneButton } from '../../components/PaneButton';
import { Form } from '../../components/Form';
import { useOrgId } from '../../auth';
import { useHasPermission } from '../../auth';
import { Permissions } from '@rivison-inc/ft-types';
import { SiteTypeForm } from '../../forms/SiteTypeForm';
import { useAddSiteType } from '../../data/siteTypes';
import { BackButton } from '../../components/BackButton';

export function AddSiteTypePage() {
  const history = useHistory();
  const orgId = useOrgId();
  const canWrite = useHasPermission(Permissions.SETTINGS_WRITE);
  const { addSiteType } = useAddSiteType();
  if (!canWrite) {
    return <></>;
  }

  return (
    <Form 
      initialValues={{
        name: '',
        orgId: orgId || '',
      }}
      onSubmit={async (siteType) => {
        await addSiteType(siteType);
        history.goBack();
      }}
    >
      <Panes 
        backgroundColor="light"
        leftButton={<BackButton />}
      >
        <Pane 
          title="Add Site Type"
          rightButton={<SubmitButton as={PaneButton} showFeedback label="Add" />}
        >
          <SiteTypeForm />
        </Pane>
      </Panes>
    </Form>
  )
}
  
